<div *ngIf="(priceListCmsBlock$ | async)?.activated">
	<h1>{{"Pricelists" | translate}}</h1>
	<i class="fa-solid fa-link"></i>&nbsp;<a target='_blank' href="{{priceListUrlDE}}">{{priceListLabelDE}}</a> <br>
	<i class="fa-solid fa-link"></i>&nbsp;<a target='_blank' href="{{priceListUrlEN}}">{{priceListLabelEN}}</a>
</div>
